import { Dispatch } from '@reduxjs/toolkit';
import { ApiRequestError } from './api-request';

export const setErrorToast = (error: ApiRequestError, dispatch: Dispatch) => {
  if (error.name === 'HttpError' && error.body['statusCode'] !== 400) {
    const details = {
      path: error.body['path'],
      code: error.body['statusCode'],
      userMessage: error.body['userMessage'],
      timestamp: error.body['timestamp'],
      errors: error.body['errors'],
      link: error.body['link'],
    };
    dispatch({
      type: 'metaData/setToast',
      payload: {
        message: `An error has occurred. Click the copy button and paste error message in
        #reema-app-help channel with steps taken when error occurred. ${
          error?.body['userMessage']
            ? ` error message:  ${error.body['userMessage']}`
            : ''
        }`,
        severity: 'error',
        details,
      },
    });
  }
};
